import { SERVER_URL, COMMON_HEADERS } from '@/config/serverUrl';
import { useAuthStore } from '@/auth/authStore';
function getAuthToken() { return useAuthStore.getState().token ?? ''; }

export interface IapProduct {
  id: string;
  productId: string;
  /** Google Play SKU when it differs from productId (else null). */
  androidProductId?: string | null;
  name: string;
  description: string | null;
  rewardKind: 'gems' | 'coins';
  rewardAmount: number;
  bonusAmount: number;
  priceUsd: number | null;
  badge: string | null;
  imageUrl: string | null;
  sortOrder: number;
}

export async function fetchIapProducts(): Promise<IapProduct[]> {
  const res = await fetch(`${SERVER_URL}/shop/iap`, { headers: COMMON_HEADERS });
  if (!res.ok) throw new Error(`fetchIapProducts: ${res.status}`);
  const data = await res.json();
  return data.items as IapProduct[];
}

export async function verifyIapPurchase(opts: {
  transactionId: string;
  productId: string;
  platform: 'ios' | 'android';
  rcUserId: string;
}): Promise<{ gems: number; coins: number }> {
  const token = getAuthToken();
  const res = await fetch(`${SERVER_URL}/shop/iap/verify`, {
    method: 'POST',
    headers: { ...COMMON_HEADERS, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(opts),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({})) as any;
    throw new Error(err?.error ?? `verify: ${res.status}`);
  }
  return res.json();
}
